export default __webpack_public_path__ + "static/media/siemens.8f5f5b44.svg";